import React from "react";
import { useTranslation } from "react-i18next";
import { getAdminTabMetricColumns } from "../../config/adminTabMetricColumns";
import type { AdminHotelMetricRow } from "../../types/adminHotelMetricTable";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminReviewsHotelsTableProps = {
  rows: AdminHotelMetricRow[];
  loading?: boolean;
};

export const AdminReviewsHotelsTable = ({
  rows,
  loading = false,
}: AdminReviewsHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();
  const columns = React.useMemo(() => getAdminTabMetricColumns("reviews"), []);

  return (
    <AdminHotelsMetricTable
      tab="reviews"
      columns={columns}
      rows={rows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.reviews.table.empty",
        "No reviews data for the selected period.",
      )}
    />
  );
};
